module.exports = __webpack_public_path__ + "static/media/latrine_tn.f197ed36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/latrine_tn.jpg
// module id = 774
// module chunks = 0